import Swal from 'sweetalert2';

export const createFaxConfirmationSwal = () => Swal.mixin({
    customClass: {
        popup: 'rounded-lg shadow-2xl border border-gray-100',
        icon: 'mt-7 mb-2 border-amber-300 text-amber-400',
        title: 'text-xl font-semibold text-gray-800 px-8 pt-0',
        htmlContainer: 'text-sm text-gray-600 mt-2 px-8',
        actions: 'gap-3 mt-6 mb-7',
        cancelButton: 'min-w-[96px] h-10 px-4 rounded border border-gray-300 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300',
        confirmButton: 'min-w-[132px] h-10 px-4 rounded bg-blue-700 text-white text-sm font-semibold hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-300',
    },
    buttonsStyling: false,
});

export const getFaxConfirmationOptions = ({
    title = 'Confirm Fax Sending',
    text = 'Do you want to send this fax?',
    confirmButtonText = 'Yes, Send Fax',
    cancelButtonText = 'Cancel',
    ...options
} = {}) => ({
    title,
    text,
    icon: 'warning',
    width: 430,
    padding: '0 0 4px',
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: false,
    focusCancel: true,
    ...options,
});

export const confirmSendFax = async (options = {}) => {
    const swalWithTailwindButtons = createFaxConfirmationSwal();
    const result = await swalWithTailwindButtons.fire(getFaxConfirmationOptions(options));

    return result.isConfirmed;
};
